module.exports = __webpack_public_path__ + "static/img/Documentos_PIE.d38852e5.png";